import React from 'react';

// 04-enforce.md 4.1 -- extraído de SubPanelTratos.jsx (rama `isCotiza` del tab "Parámetros"):
// el formulario de cotización de terminales. Era ~145 líneas de `op-sub-panel-field` repetidos;
// acá se describe como datos (`SECTIONS`) y se renderiza con un helper, misma salida DOM. El
// único input real llega por la render-prop `renderAutoInput` (closure sobre `formData` del
// container).

const DIVIDER_STYLE = {
  margin: 'var(--space-5) 0 var(--space-4) 0',
  borderBottom: '1px dashed rgba(255,255,255,0.08)',
  paddingBottom: 'var(--space-1)',
  fontSize: '11px',
  fontWeight: '700',
  color: '#f97316',
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
};

// Cada sección: título de divider (o null para la primera) + filas. Una fila con 1 campo se
// renderiza suelta; con 2, dentro de un `op-sub-panel-row`.
const SECTIONS = [
  {
    divider: null,
    rows: [
      [
        { label: 'Folio', field: 'cotizacion_folio', type: 'text', placeholder: 'Ej: COT-2026-001' },
        { label: 'Fecha', field: 'cotizacion_fecha', type: 'date' },
      ],
      [{ label: 'Nombre del Cliente', field: 'cotizacion_cliente_nombre', type: 'text', placeholder: 'Nombre completo del cliente' }],
      [{ label: 'Empresa o Razón Social', field: 'cotizacion_cliente_empresa', type: 'text', placeholder: 'Empresa o Razón Social' }],
      [
        { label: 'RFC', field: 'cotizacion_cliente_rfc', type: 'text', placeholder: 'RFC' },
        { label: 'Mail del Cliente', field: 'cotizacion_cliente_mail', type: 'email', placeholder: 'cliente@ejemplo.com' },
      ],
    ],
  },
  {
    divider: 'Datos del Ejecutivo',
    rows: [
      [{ label: 'Nombre de Ejecutivo', field: 'cotizacion_ejecutivo_nombre', type: 'text', placeholder: 'Nombre del ejecutivo' }],
      [
        { label: 'Teléfono', field: 'cotizacion_ejecutivo_telefono', type: 'tel', placeholder: 'Teléfono de contacto' },
        { label: 'Mail de Ejecutivo', field: 'cotizacion_ejecutivo_mail', type: 'email', placeholder: 'ejecutivo@ejemplo.com' },
      ],
    ],
  },
  {
    divider: 'Productos Incluidos',
    rows: [
      [
        { label: 'Número de terminales', field: 'cotizacion_prod_numero', type: 'number', placeholder: 'Cant. de terminales' },
        { label: 'Tipo de terminal', field: 'cotizacion_prod_tipo', type: 'text', placeholder: 'Ej: Smart, Android, etc.' },
      ],
      [
        { label: 'Costo por terminal', field: 'cotizacion_prod_costo', type: 'text', placeholder: 'Costo unitario' },
        { label: 'Total + IVA', field: 'cotizacion_prod_total', type: 'text', placeholder: 'Total final con IVA' },
      ],
    ],
  },
  {
    divider: 'Tasas de Terminales',
    rows: [
      [
        { label: 'Nacional Débito', field: 'cotizacion_tasa_nac_deb', type: 'text', placeholder: 'Ej: 1.5%' },
        { label: 'Nacional Crédito', field: 'cotizacion_tasa_nac_cred', type: 'text', placeholder: 'Ej: 2.2%' },
      ],
      [
        { label: 'Internacional Débito', field: 'cotizacion_tasa_int_deb', type: 'text', placeholder: 'Ej: 3.5%' },
        { label: 'Internacional Crédito', field: 'cotizacion_tasa_int_cred', type: 'text', placeholder: 'Ej: 3.8%' },
      ],
      [
        { label: 'Amex', field: 'cotizacion_tasa_amex', type: 'text', placeholder: 'Ej: 4.0%' },
        { label: 'Crypto', field: 'cotizacion_tasa_crypto', type: 'text', placeholder: 'Ej: 1.0%' },
      ],
    ],
  },
];

const SubPanelCotizacion = ({ renderAutoInput }) => {
  const renderField = ({ label, field, type, placeholder }) => (
    <div className="op-sub-panel-field" key={field}>
      <label>{label}</label>
      {renderAutoInput(field, type, placeholder ? { placeholder } : {})}
    </div>
  );

  return (
    <div className="op-sub-panel-cotizacion-fields">
      {SECTIONS.map((section, si) => (
        <React.Fragment key={section.divider || si}>
          {section.divider && <div style={DIVIDER_STYLE}>{section.divider}</div>}
          {section.rows.map((row, ri) =>
            row.length === 1
              ? renderField(row[0])
              : <div className="op-sub-panel-row" key={`row-${si}-${ri}`}>{row.map(renderField)}</div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default SubPanelCotizacion;
